export const TOAST_MESSAGE_SUCCESS = 'TOAST_MESSAGE_SUCCESS';
export const TOAST_MESSAGE_WARNING = 'TOAST_MESSAGE_WARNING';
export const TOAST_MESSAGE_ERROR  = 'TOAST_MESSAGE_ERROR';
export const TOAST_MESSAGE_CLEAN = 'TOAST_MESSAGE_CLEAN';